module.exports = __webpack_public_path__ + "static/media/icon-dashboard-approved.df35152c.svg";